export const bookingManagementPageNamesMap = {
    // Menus
    'mybooking/booking-documentation': 'mybooking/booking-documentation',
    'mybooking/billing-information': 'mybooking/billing-information',
    'mybooking/additional-services': 'mybooking/additional-services',
    'mybooking/app-web-redirect': 'mybooking/app-web-redirect',
    'direct-chat-redirection': 'direct-chat-redirection',
    // Modifications
    'travel-dates': 'travel-dates',
    'flights-selection': 'flights-selection',
    'mybooking/voluntary-changes-2/travel-dates/dates-not-allowed': 'mybooking/voluntary-changes-2/travel-dates/dates-not-allowed',
    'mybooking/voluntary-changes-2/flights/results': 'mybooking/voluntary-changes-2/flights/results',
    'mybooking/voluntary-changes-2/flights/itinerary': 'mybooking/voluntary-changes-2/flights/itinerary',
    'mybooking/voluntary-changes-2/flights/summary': 'mybooking/voluntary-changes-2/flights/summary',
    'mybooking/voluntary-changes-2/flights/itinerary/total-estimated-price-info':
        'mybooking/voluntary-changes-2/flights/itinerary/total-estimated-price-info',
    'mybooking/voluntary-changes-2/flights/summary/total-estimated-price-info':
        'mybooking/voluntary-changes-2/flights/summary/total-estimated-price-info',
    'mybooking/voluntary-changes-2/travel-dates-europ-assistance-how-to': 'mybooking/voluntary-changes-2/travel-dates-europ-assistance-how-to',
    'mybooking/voluntary-changes-2/change-request-confirmation': 'mybooking/voluntary-changes-2/change-request-confirmation',
    'mybooking/voluntary-changes-2/contact-airline': 'mybooking/voluntary-changes-2/contact-airline',
    'mybooking/voluntary-changes-2/travel-dates/error': 'mybooking/voluntary-changes-2/travel-dates/error',
    'mybooking/voluntary-changes-2/travel-dates/error/no-results': 'mybooking/voluntary-changes-2/travel-dates/error/no-results',
    'mybooking/voluntary-changes-2/search-expired': 'mybooking/voluntary-changes-2/search-expired',
    'mybooking/voluntary-changes-2/flights/summary/double-protection-info': 'mybooking/voluntary-changes-2/flights/summary/double-protection-info',
    'mybooking/voluntary-changes-2/flights/payment/error': 'mybooking/voluntary-changes-2/flights/payment/error',
    'mybooking/voluntary-changes-2/flights/pending-3dsecure-confirmation': 'mybooking/voluntary-changes-2/flights/pending-3dsecure-confirmation',
    'mybooking/voluntary-changes-2/flights/redirection-3dsecure': 'mybooking/voluntary-changes-2/flights/redirection-3dsecure',
    'mybooking/voluntary-changes-2/flights/3dsecure/payment-rejected': 'mybooking/voluntary-changes-2/flights/3dsecure/payment-rejected',
    'mybooking/voluntary-changes-2/flights/summary/error/collection': 'mybooking/voluntary-changes-2/flights/summary/error/collection',
    'mybooking/voluntary-changes-2/flights/summary/error/error_500':
        'mybooking/voluntary-changes-2/flights/summary/error/error_500',
    'mybooking/voluntary-changes-2/flights/payment/error/error_500': 'mybooking/voluntary-changes-2/flights/payment/error/error_500',
    'mybooking/voluntary-changes-2/flights/3dsecure/authentication-not-finished':
        'mybooking/voluntary-changes-2/flights/3dsecure/authentication-not-finished',
    'mybooking/voluntary-changes-2/flights/3dsecure': 'mybooking/voluntary-changes-2/flights/3dsecure',
    'mybooking/voluntary-changes-2/direct-chat-offline': 'mybooking/voluntary-changes-2/direct-chat-offline',
    'mybooking/voluntary-changes-2/direct-chat-redirection': 'mybooking/voluntary-changes-2/direct-chat-redirection',
    'mybooking/voluntary-changes-2/direct-chat-leave': 'mybooking/voluntary-changes-2/direct-chat-leave',
    'mybooking/voluntary-changes-2/changes-not-allowed/direct-chat': 'mybooking/voluntary-changes-2/changes-not-allowed/direct-chat',
    'mybooking/voluntary-changes-2/service-na-error': 'mybooking/voluntary-changes-2/service-na-error',
    '3dsecure': '3dsecure',
    // Alternatives
    'cancelled-flights': 'cancelled-flights',
    'alternative-flight-auto': 'alternative-flight-auto',
    'alternative-flight': 'alternative-flight',
    'refund-request': 'refund-request',
    'alternative-flight-details': 'alternative-flight-details',
    'no-alternative-flight': 'no-alternative-flight',
    'airline-help': 'airline-help',
    'refund-confirmation': 'refund-confirmation',
    'alternative-flight/search': 'alternative-flight/search',
    'alternative-flight/search-results': 'alternative-flight/search-results',
    'alternative-flight/error/search-no-results': 'alternative-flight/error/search-no-results',
    'change-flight-confirmation': 'change-flight-confirmation',
    'error/change-flight-error': 'error/change-flight-error',
    // Cancellation
    'cancel-your-trip': 'cancel-your-trip',
    'voucher-acceptance': 'voucher-acceptance',
    'cancellation-summary': 'cancellation-summary',

    'cancellation-warning': 'cancellation-warning',
    'cancellation-request-confirmation': 'cancellation-request-confirmation',
    'change-request-confirmation': 'change-request-confirmation',
    'travel-dates-europ-assistance-how-to': 'travel-dates-europ-assistance-how-to',
    'airline-redirection-cancellation': 'airline-redirection',
    // Hotel Cancellation
    'mybooking/hotel-cancellation/cancellation-reason': 'cancellation-reason',
    'mybooking/hotel-cancellation/error/booking-options-retrieval': 'error/booking-options-retrieval',
    'mybooking/hotel-cancellation/booking-not-cancellable': 'booking-not-cancellable',
    'mybooking/hotel-cancellation/review-cancellation-request': 'review-cancellation-request',
    'mybooking/hotel-cancellation/cancellation-policy': 'cancellation-policy',
    'mybooking/hotel-cancellation/last-chance': 'last-chance',
    'mybooking/hotel-cancellation/cancellation-confirmation': 'cancellation-confirmation',
    'mybooking/hotel-cancellation/error/cancellation-error': 'error/cancellation-error',
    'mybooking/voluntary-changes-2/add-primeplus/xfaring': 'mybooking/voluntary-changes-2/add-primeplus/xfaring',
    'mybooking/voluntary-changes-2/add-primeplus/total-price': 'mybooking/voluntary-changes-2/add-primeplus/total-price',
    'mybooking/voluntary-changes-2/add-primeplus/estimated-price': 'mybooking/voluntary-changes-2/add-primeplus/estimated-price',
    // LCC disruptions
    'mybooking/modify-trip/airline-changes-cancellations': 'mybooking/modify-trip/airline-changes-cancellations',
    'mybooking/modify-trip/airline-changes-cancellations/booking-details': 'mybooking/modify-trip/airline-changes-cancellations/booking-details',
};
